<template>
  <layout page-title="Matrix">
    <!-- Primary column -->
    <section
      class="
        min-w-0
        flex-1
        h-full
        flex flex-col
        lg:order-last
        relative
        pt-10
        sm:pt-6
        lg:pt-0
      "
    >
      <div class="mt-4 px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col">
          <div class="-my-2 py-2 sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
            <!-- overflow-x-auto -->
            <!-- Page Header: start -->
            <div
              v-if="false"
              class="md:flex md:items-center md:justify-between"
            >
              <div class="flex-1 min-w-0">
                <h2
                  class="
                    text-2xl
                    font-light
                    leading-7
                    text-gray-900
                    sm:text-2xl sm:leading-9 sm:truncate
                  "
                >
                  Lexikon - Matrix
                </h2>
              </div>
              <div class="mt-1 flex md:mt-0 md:ml-4">
                <span class="mr-3 shadow-sm rounded-md">
                  <Link
                    v-if="false"
                    :href="route('markencode.dictionary.index')"
                    class="
                      inline-flex
                      items-center
                      px-4
                      py-2
                      border border-transparent
                      text-xs
                      2xl:text-sm
                      leading-5
                      font-medium
                      rounded-md
                      text-gray-500
                      bg-gray-200
                      hover:bg-gray-300
                      focus:outline-none focus:ring-gray focus:border-gray-400
                      active:bg-gray-400
                      transition
                      duration-150
                      ease-in-out
                    "
                    >Zum Dashboard</Link
                  >
                </span>

                <span
                  v-if="$page.props.auth.user.can.classifyWords"
                  class="sm:ml-3 shadow-sm rounded-md"
                >
                  <!--Link
                  :href="route('markencode.dictionary.create')"
                  class="inline-flex items-center px-4 py-2 border border-transparent text-xs 2xl:text-sm leading-5 font-medium rounded-md text-white bg-markencode-red hover:bg-red-500 focus:outline-none focus:ring-red focus:border-red-700 active:bg-red-700 transition duration-150 ease-in-out"
                >Neues Wort</Link-->
                </span>
              </div>
            </div>
            <!-- Page Header: end -->

            <horizontal-divider v-if="false" />

            <!-- List: start -->

            <div class="w-full flex flex-col md:flex-row items-start">
              <div class="w-full md:w-1/2 xl:w-1/4 md:mr-4">
                <matrix
                  class="w-full sm:w-1/2 md:w-full mx-auto md:mr-5"
                  :initialZone="form.zone"
                  :forceEnabled="true"
                  @selected="zoneSelected"
                ></matrix>
              </div>

              <div class="w-full md:flex-1">
                <!-- Filter: start -->
                <div class="flex flex-col sm:flex-row mb-4 items-center">
                  <div class="sm:w-10/12 mr-2">
                    <div class="mt-1 relative rounded-md shadow-sm">
                      <div
                        class="
                          absolute
                          inset-y-0
                          left-0
                          pl-3
                          flex
                          items-center
                          pointer-events-none
                        "
                      >
                        <svg
                          class="h-5 w-5 text-gray-400"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </div>
                      <input
                        type="text"
                        class="
                          pl-10
                          focus:ring-markencode-blue focus:border-markencode-blue
                          block
                          w-full
                          shadow-sm
                          text-xs
                          2xl:text-sm
                          border-gray-300
                          rounded-md
                        "
                        placeholder="Suchen nach..."
                        v-model="form.search"
                      />
                    </div>
                  </div>

                  <div class="w-2/12 text-center">
                    <clear-filter-button
                      :is-filtered="isFiltered"
                      @filterResetted="reset"
                    ></clear-filter-button>
                  </div>
                </div>

                <word-attributes-filter
                  :word-categories="wordCategories"
                  :selected-word-attributes="form.wordAttributes"
                  :selected-logical-operator="
                    form.wordAttributesLogicalOperator
                  "
                  @attributesToggled="wordAttributesToggled"
                  @logicalOperatorSet="wordAttributesLogicalOperatorSet"
                ></word-attributes-filter>

                <!-- Filter: end -->

                <!-- <p v-if="!words.length" class="text-sm">
                  Es liegen keine Worte vor.
                </p> -->

                <ul
                  class="
                    mt-3
                    grid grid-cols-1
                    gap-2
                    md:gap-2
                    sm:gap-2 sm:grid-cols-2
                    xl:grid-cols-4
                    3xl:grid-cols-5
                  "
                >
                  <word-item-slim
                    v-for="(word, idx) in allWords"
                    :key="idx"
                    :word="word"
                  ></word-item-slim>
                </ul>

                <div v-if="!allWords.length" class="text-sm text-gray-500">
                  Es liegen keine Worte vor.
                </div>

                <div class="w-full flex items-center justify-center">
                  <pagination
                    v-if="showPagination"
                    :query-params="queryParams"
                    :current-page="words.meta.current_page"
                    :last-page="words.meta.last_page"
                    route-name="markencode.matrix.index"
                  ></pagination>
                </div>
              </div>
            </div>

            <!-- List: end -->
          </div>
        </div>
      </div>

      
    </section>

    
  </layout>
</template>

<script>
import Layout from '@/Pages/Markencode/Shared/Layout.vue';

import WordItemSlim from '@/Pages/Markencode/Shared/WordItemSlim.vue';
import Matrix from '@/Pages/Markencode/Matrix/Shared/Matrix.vue';
import ClearFilterButton from '@/Shared/ClearFilterButton.vue';
import Pagination from '@/Shared/Pagination.vue';
import WordAttributesFilter from '@/Pages/Markencode/Shared/WordAttributesFilter.vue';

import { throttle, some, isNotEmpty } from 'lodash';

export default {
  components: {
    Layout,
    
    Matrix,
    WordItemSlim,
    ClearFilterButton,
    Pagination,
    WordAttributesFilter,
  },

  props: {
    filters: Object,
    wordClassifiers: Array,
    wordCategories: Array,
    words: Object,

    queryParams: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      allWords: this.words.data,
      form: {
        search: this.filters.search,
        // zone: this.filters.zone || { id: 'd', zone_colors: 'r' },
        zone: this.filters.zone || 'd',

        wordAttributes: this.filters.wordAttributes
          ? this.filters.wordAttributes.map(Number)
          : [],
        wordAttributesLogicalOperator:
          this.filters.wordAttributesLogicalOperator || 'or',
      },
    };
  },

  watch: {
    words: function () {
      this.allWords = this.words.data;
    },

    form: {
      handler: throttle(function () {
        this.$inertia.get(
          this.route('markencode.matrix.index'),
          {
            ...this.queryParams,
            search: this.form.search,
            zone: this.form.zone,
            wordAttributes: this.form.wordAttributes,
            wordAttributesLogicalOperator:
              this.form.wordAttributesLogicalOperator,
            page: 1,
          },
          { only: ['words', 'filters', 'queryParams'], preserveState: true }
        );
      }, 150),

      deep: true,
    },
  },

  methods: {
    zoneSelected(zone) {
      // this.form.zone = zone;

      this.$inertia.get(
        this.route('markencode.matrix.index', { zone: zone })
      );
    },

    wordAttributesToggled(attributes) {
      this.form.wordAttributes = attributes;
    },

    wordAttributesLogicalOperatorSet(logicalOperator) {
      this.form.wordAttributesLogicalOperator = logicalOperator;
    },

    reset() {
      this.$inertia.get(
        this.route('markencode.matrix.index', { zone: 'd' }),
        {}
      );
      // this.form.search = '';
      // this.form.status = '';
      // this.form.wordAttributes = [];
      // this.form.wordAttributesLogicalOperator = 'or';
    },
  },

  computed: {
    isFiltered() {
      return some(this.form, isNotEmpty);
    },

    showPagination() {
      if (this.words.meta.total > this.words.meta.per_page) {
        return true;
      }

      return false;
    },
  },
};
</script>
